import { ChakraProps, css, useTheme } from '@chakra-ui/react';
import { useMemo } from 'react';

// TODO: remove layerStyle/textStyle workaround
// https://github.com/chakra-ui/chakra-ui/issues/3884

type UseChakraPrioritStylesProps = Pick<
  ChakraProps,
  'layerStyle' | 'textStyle'
>;

export const useChakraPriorityStyles = ({
  layerStyle,
  textStyle,
}: UseChakraPrioritStylesProps) => {
  const theme = useTheme();

  const styles = {
    layerStyle,
    textStyle,
  };

  const finalCss = useMemo(
    () => css(styles)(theme),
    [JSON.stringify(styles), theme],
  );

  return {
    css: finalCss,
  };
};
